module.exports = __webpack_public_path__ + "img/empty.46562ba5.webp";